import { useState } from 'react';
import { color, s8sColor } from '../common/themes';

const IconVoice = ({
	onClick = () => {},
	className,
	id,
	width = 24,
	height = 24,
	iconColor = s8sColor.neutral.gray800,
	disabled,
}: any) => {
	const [isHover, setIsHover] = useState(false);

	const strokeColor = disabled ? color.$8 : isHover ? s8sColor.brand.hover : iconColor;
	const fillColor = disabled ? color.$8 : isHover ? s8sColor.brand.hover : iconColor;

	return (
		<svg
			id={id}
			width={width}
			height={height}
			viewBox={`0 0 ${width} ${height}`}
			onMouseEnter={() => setIsHover(true)}
			onMouseLeave={() => setIsHover(false)}
			onClick={() => {
				if (disabled) return;
				onClick();
			}}
			className={className}
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path d="M12 17.9385V20.9385" stroke={strokeColor} strokeWidth={2} strokeLinecap="round" />
			<path
				d="M18 13C17.6736 13.7861 17.1953 14.5005 16.5922 15.1022C15.9891 15.7038 15.2732 16.1811 14.4853 16.5068C13.6973 16.8324 12.8529 17 12 17C11.1471 17 10.3026 16.8324 9.51472 16.5068C8.72679 16.1811 8.01086 15.7038 7.4078 15.1022C6.80474 14.5005 6.32637 13.7861 6 13"
				stroke={strokeColor}
				strokeWidth={2}
				strokeLinecap="round"
			/>
			<rect x={8} y={4} width={8} height={10} rx={4} fill={fillColor} />
		</svg>
	);
};

export default IconVoice;
